const ORGANISMS = [];

export default ORGANISMS;
